import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AddToCartButtonComponent} from './add-to-cart-button.component';
import {
    CartLineQuantitySetterModule
} from "@app/presentation/components/cart-line-quantity-setter/cart-line-quantity-setter.module";
import {
    RemoveCartLineFromCartModule
} from "@app/presentation/components/remove-cart-line-from-cart/remove-cart-line-from-cart.module";


@NgModule({
  declarations: [
    AddToCartButtonComponent,
  ],
    imports: [
        CommonModule,
        CartLineQuantitySetterModule,
        RemoveCartLineFromCartModule,
    ],
    exports: [
        AddToCartButtonComponent,
    ]
})
export class AddToCartButtonModule { }
